var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("v-symbols"),
      _c(
        "transition",
        {
          attrs: { name: "page" },
          on: {
            enter: _vm.pageTransition,
            "after-enter": _vm.afterPageEnter,
            "before-leave": _vm.beforePageLeave,
            leave: _vm.pageTransition,
            "after-leave": _vm.afterPageLeave,
          },
        },
        [
          _vm.initialized
            ? _c("router-view", { key: _vm.$route.fullPath })
            : _vm._e(),
        ],
        1
      ),
      _c("transition", [
        _vm.$store.state.loading
          ? _c(
              "div",
              {
                staticClass: "app__loading",
                class: {
                  "app__loading--initializing": !_vm.initialized,
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("loading")) + "... ")]
            )
          : _vm._e(),
      ]),
      !_vm.isPageResult
        ? _c("v-sticky-buttons", { on: { toggleSound: _vm.toggleSound } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }